module.exports = __webpack_public_path__ + "static/media/cosmos.e915ff17.svg";